"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "10",
  viewBox: "0 0 16 10"
}, _react.default.createElement("path", {
  d: "M4.86 7.6A15.34 15.34 0 012.13 5c.71-.88 1.7-1.84 2.73-2.6C6.03 1.54 7.17 1 8 1c.83 0 1.97.54 3.14 1.4 1.03.76 2.02 1.72 2.73 2.6-.71.88-1.7 1.84-2.73 2.6C9.97 8.46 8.83 9 8 9c-.83 0-1.97-.54-3.14-1.4zM8 0C6.83 0 5.47.71 4.27 1.6c-1.23.9-2.39 2.06-3.17 3.1L.87 5l.23.3c.78 1.04 1.94 2.2 3.17 3.1C5.47 9.3 6.83 10 8 10s2.53-.71 3.73-1.6c1.23-.9 2.39-2.06 3.17-3.1l.22-.3-.22-.3a16.04 16.04 0 00-3.17-3.1C10.53.7 9.17 0 8 0zM6.5 5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM8 2.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
}));

exports.default = _default;